import React from 'react'

export class Accordion extends React.Component {
  setActive = () => {
    const target = this.props.active === this.props.id ? null : this.props.id
    console.log(target)
    this.props.setActive(target)
  }

  render() {
    const isActive = this.props.active === this.props.id

    return <div className="accordion" open={isActive}>
      <label className="accordion-header c-hand" htmlFor={this.props.id} onClick={this.setActive}>
        <i className={`fas fa-angle-${isActive ? 'down' : 'right'}`}></i> <strong>{this.props.title}</strong>
      </label>
      <div className="accordion-body">
        {this.props.children}
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/accordion.jsx